/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteMenuVersion } from '../fn/menu-versions/delete-menu-version';
import { DeleteMenuVersion$Params } from '../fn/menu-versions/delete-menu-version';
import { releaseMenuVersion } from '../fn/menu-versions/release-menu-version';
import { ReleaseMenuVersion$Params } from '../fn/menu-versions/release-menu-version';
import { releaseScheduledMenuVersion } from '../fn/menu-versions/release-scheduled-menu-version';
import { ReleaseScheduledMenuVersion$Params } from '../fn/menu-versions/release-scheduled-menu-version';

@Injectable({ providedIn: 'root' })
export class MenuVersionsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `releaseMenuVersion()` */
  static readonly ReleaseMenuVersionPath = '/menus/{menuId}/release';

  /**
   * Release a menu version.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `releaseMenuVersion()` instead.
   *
   * This method doesn't expect any request body.
   */
  releaseMenuVersion$Response(params: ReleaseMenuVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return releaseMenuVersion(this.http, this.rootUrl, params, context);
  }

  /**
   * Release a menu version.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `releaseMenuVersion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  releaseMenuVersion(params: ReleaseMenuVersion$Params, context?: HttpContext): Observable<void> {
    return this.releaseMenuVersion$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `releaseScheduledMenuVersion()` */
  static readonly ReleaseScheduledMenuVersionPath = '/menus/{menuId}/schedule-menu-release';

  /**
   * Schedule menu version for release.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `releaseScheduledMenuVersion()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  releaseScheduledMenuVersion$Response(params: ReleaseScheduledMenuVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return releaseScheduledMenuVersion(this.http, this.rootUrl, params, context);
  }

  /**
   * Schedule menu version for release.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `releaseScheduledMenuVersion$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  releaseScheduledMenuVersion(params: ReleaseScheduledMenuVersion$Params, context?: HttpContext): Observable<void> {
    return this.releaseScheduledMenuVersion$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteMenuVersion()` */
  static readonly DeleteMenuVersionPath = '/menus/{menuId}/version';

  /**
   * Delete a menu version.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMenuVersion()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMenuVersion$Response(params: DeleteMenuVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteMenuVersion(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a menu version.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMenuVersion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMenuVersion(params: DeleteMenuVersion$Params, context?: HttpContext): Observable<void> {
    return this.deleteMenuVersion$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
